// imports
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { ICON } from '../../../assets';
import PrimaryButton from '../../button/primary';
import { IActionItem } from '../../../common/types';
import { selectUserQuests } from '../../../repositories/store/slices';

// interfaces / types / consts
interface Props {
  className?: string;
  items: IActionItem[];
  defaultSelectIdx?: number;
}

// exports
export default function Dropdown(props: Props): JSX.Element {
  const { items, defaultSelectIdx = 0, className } = props;
  // hooks configuration
  const { startId, claimId } = useSelector(selectUserQuests);
  const [activeItem, setActiveItem] = useState(items[defaultSelectIdx].display || items[defaultSelectIdx].key);
  useEffect(() => {
    const itemPresent = Boolean(items.filter((item) => item.key === activeItem || item.display === activeItem).length);
    if (!itemPresent) {
      const defaultItem = items[defaultSelectIdx];
      setActiveItem(defaultItem.display || defaultItem.key);
      if (defaultItem.onClick) { defaultItem.onClick(); }
    }
  }, [items, activeItem, defaultSelectIdx]);
  // render
  return (
    <div className="dropdown-container">
      <PrimaryButton
        size="md-skinny"
        text={activeItem}
        toggleElem="dropdown"
        rightIcon={ICON.DROPDOWN_ARROW}
        className={clsx('dropdown', className)}
        disabled={Boolean(startId) || Boolean(claimId)}
      />
      <ul className="dropdown-body dropdown-menu">
        {items.map((item) => (
          <li key={item.key}>
            <button
              type="button"
              className="dropdown-item"
              onClick={() => {
                setActiveItem(item.display || item.key);
                if (item.onClick) { item.onClick(); }
              }}
            >
              {item.display || item.key}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

// default props
Dropdown.defaultProps = { defaultSelectIdx: 0, className: '' };
